import { render, staticRenderFns } from "./ModalPopupSchemes.vue?vue&type=template&id=62201526&"
import script from "./ModalPopupSchemes.vue?vue&type=script&lang=js&"
export * from "./ModalPopupSchemes.vue?vue&type=script&lang=js&"
import style0 from "./ModalPopupSchemes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports